import React from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { operators } from "../data/site";

const A = operators.accommodation;
const W = operators.winery;

function formatAddress(addr) {
  return `${addr.street}, ${addr.postal} ${addr.city}`;
}

export function ObchodniPodminky() {
  return (
    <Legal path="/obchodni-podminky" title="Obchodní podmínky" crumb="Obchodní podmínky">
      <p className="text-sm text-charcoal/70">
        Značka „Vinařství Brychta" je společně užívána dvěma samostatnými podnikajícími
        fyzickými osobami. Ubytování a rodinný pobyt poskytuje {A.name} (IČO&nbsp;{A.ico}).
        Prodej vína a degustace poskytuje {W.name} (IČO&nbsp;{W.ico}).
      </p>

      <h2 id="ubytovani">Ubytování</h2>
      <p><strong>Poskytovatel:</strong> {A.name}, IČO&nbsp;{A.ico}, sídlo&nbsp;{formatAddress(A.registeredAddress)}. Místo poskytování ubytování: {formatAddress(A.operatingAddress)}. Kontakt: <a href={`mailto:${A.email}`}>{A.email}</a>, {A.phone}. Fyzická osoba podnikající zapsaná v&nbsp;živnostenském rejstříku; není plátcem DPH.</p>

      <h3>Ceny a délka pobytu</h3>
      <ul>
        <li>500 Kč / osoba / noc od 1.&nbsp;dubna do 31.&nbsp;října.</li>
        <li>600 Kč / osoba / noc od 1.&nbsp;listopadu do 31.&nbsp;března včetně.</li>
        <li>Účtuje se skutečný počet ubytovaných osob, včetně dětí, které mají stejnou cenu jako dospělí.</li>
        <li>Není stanovena minimální cena apartmánu.</li>
        <li>Minimální délka pobytu jsou 2&nbsp;noci.</li>
        <li>Konkrétní apartmán i dostupnost potvrzuje poskytovatel ubytování individuálně po přijetí poptávky.</li>
      </ul>

      <h3>Místní poplatek z pobytu</h3>
      <p>
        Kromě ceny pobytu se odvádí místní poplatek z&nbsp;pobytu ve&nbsp;výši 25&nbsp;Kč
        za&nbsp;osobu starší 18&nbsp;let a&nbsp;noc podle obecně závazné vyhlášky města Břeclav.
        Poplatek není zahrnut v&nbsp;ceně ubytování ani v&nbsp;ceně rodinného pobytu a&nbsp;vybírá se zvlášť.
      </p>

      <h3>Rezervace a záloha</h3>
      <ul>
        <li>Odeslaná poptávka není závaznou rezervací. Poskytovatel po přijetí poptávky zašle nezávaznou nabídku a&nbsp;platební pokyny.</li>
        <li>K&nbsp;závaznému rezervování termínu je třeba uhradit zálohu ve&nbsp;výši 50&nbsp;%&nbsp;ceny ubytování. Splatnost zálohy je zpravidla 3&nbsp;dny ode&nbsp;dne odeslání platebních pokynů; není-li záloha v&nbsp;této lhůtě připsána, nabídka pozbývá platnosti a&nbsp;termín se uvolňuje pro další zájemce.</li>
        <li>Rezervace se stává závaznou dnem připsání zálohy na účet poskytovatele.</li>
        <li>Zbývající část ceny ubytování je splatná při příjezdu nebo v&nbsp;průběhu pobytu, a to bankovním převodem, QR&nbsp;platbou, hotově, případně kartou po předchozí domluvě.</li>
      </ul>

      <h3>Storno podmínky pobytu</h3>
      <ul>
        <li>Zruší-li host pobyt nejméně 30&nbsp;celých kalendářních dnů před sjednaným datem příjezdu, vrací poskytovatel uhrazenou zálohu v&nbsp;plné výši.</li>
        <li>Zruší-li host pobyt méně než 30&nbsp;kalendářních dnů před sjednaným datem příjezdu, uhrazená záloha se ponechává jako storno&nbsp;poplatek. Nezaplacený zbytek ceny pobytu se neúčtuje.</li>
        <li>Za&nbsp;den zrušení se považuje den, kdy poskytovatel obdrží písemné (e-mailové) oznámení o&nbsp;zrušení.</li>
        <li>Tyto storno podmínky se týkají výhradně ubytování a&nbsp;rodinného pobytu (viz&nbsp;níže). Samostatné degustace, pikniky, sezonní zážitky, soukromé oslavy a&nbsp;firemní akce se řídí individuálně dohodnutými podmínkami.</li>
      </ul>

      <h3>Provoz</h3>
      <ul>
        <li>Check-in od&nbsp;14:00, check-out do&nbsp;10:00.</li>
        <li>Parkování v&nbsp;areálu zdarma.</li>
        <li>Zvířata nejsou v&nbsp;apartmánech povolena.</li>
        <li>K&nbsp;dispozici je sdílený uzamykatelný prostor pro cca&nbsp;14&nbsp;kol.</li>
      </ul>

      <h2 id="rodinny-pobyt">Rodinný pobyt na jižní Moravě (9&nbsp;990 Kč)</h2>
      <p>
        Balíček je určen pro 4&nbsp;osoby (2&nbsp;dospělí + 2&nbsp;děti) na&nbsp;5&nbsp;nocí. Poskytovatelem
        vůči hostovi je {A.name} – uzavírá s&nbsp;hostem jednu smlouvu na&nbsp;celý balíček, přijímá platbu
        a&nbsp;vystavuje hostovi doklad na&nbsp;celkovou cenu 9&nbsp;990&nbsp;Kč. Součástí balíčku je vinohradová
        degustace pro 2&nbsp;dospělé, kterou technicky zajišťuje {W.name} jako spolupracující dodavatel.
      </p>
      <p><strong>Balíček zahrnuje:</strong></p>
      <ul>
        <li>5&nbsp;nocí ubytování pro 4&nbsp;osoby ve&nbsp;vhodném apartmánu podle aktuální dostupnosti.</li>
        <li>Sedmivzorkovou degustaci ve&nbsp;vinohradě pro 2&nbsp;dospělé včetně občerstvení.</li>
        <li>Nealkoholické nápoje pro 2&nbsp;děti a&nbsp;společné občerstvení během degustace.</li>
        <li>Uvítací láhev vína.</li>
        <li>Uložení kol.</li>
        <li>Doporučení rodinných výletů a&nbsp;cyklotras.</li>
      </ul>
      <p><strong>Podmínky balíčku:</strong></p>
      <ul>
        <li>Cena 9&nbsp;990&nbsp;Kč platí celoročně; nezahrnuje místní poplatek z&nbsp;pobytu (vybírá se zvlášť).</li>
        <li>Vhodný apartmán a&nbsp;dostupnost termínu potvrzujeme individuálně.</li>
        <li>K&nbsp;závaznému rezervování je třeba uhradit zálohu ve&nbsp;výši 50&nbsp;%&nbsp;ceny balíčku, splatnou zpravidla do&nbsp;3&nbsp;dnů od&nbsp;odeslání platebních pokynů; rezervace se stává závaznou dnem připsání zálohy.</li>
        <li>Zbytek ceny je splatný při příjezdu nebo v&nbsp;průběhu pobytu podle domluvy.</li>
        <li>Zruší-li host balíček nejméně 30&nbsp;celých kalendářních dnů před sjednaným datem příjezdu, vrací se záloha v&nbsp;plné výši. Zruší-li host později, záloha se ponechává jako storno&nbsp;poplatek a&nbsp;nezaplacený zbytek ceny se neúčtuje.</li>
        <li>Vinohradová část programu závisí na&nbsp;vhodném počasí. Pokud plánovaný venkovní program nelze uskutečnit, dohodneme s&nbsp;hostem individuálně vnitřní alternativu, náhradní program nebo jiný vhodný termín.</li>
        <li>Nelze-li dohodnutou službu zajistit ani po&nbsp;nabídce alternativy, vrátí poskytovatel částku odpovídající neposkytnuté části služby.</li>
      </ul>

      <h2 id="degustace">Samostatné degustace a zážitky</h2>
      <p><strong>Poskytovatel:</strong> {W.name}, IČO&nbsp;{W.ico}, sídlo&nbsp;{formatAddress(W.registeredAddress)}. Kontakt: <a href={`mailto:${W.email}`}>{W.email}</a>, {W.phone}. Fyzická osoba podnikající zapsaná v&nbsp;živnostenském rejstříku; není plátcem DPH.</p>
      <ul>
        <li>Vyplněný formulář je nezávazná poptávka.</li>
        <li>Poskytovatel individuálně potvrdí termín, rozsah, konečnou cenu a&nbsp;praktické podrobnosti.</li>
        <li>Rezervace se stává závaznou až po&nbsp;oboustranném potvrzení konečné nabídky.</li>
        <li>Způsob a&nbsp;termín platby se dohodne při potvrzení; u&nbsp;samostatných zážitků není automatická záloha.</li>
        <li>Případné storno podmínky se dohodnou individuálně před tím, než se rezervace stane závaznou. Podmínky pro ubytování na&nbsp;samostatné zážitky neplatí automaticky.</li>
        <li>Aktuální ceník degustací najdete na&nbsp;stránce Zážitky. Varianty ve&nbsp;vinohradě mají příplatek 50&nbsp;Kč / osoba.</li>
        <li>Občerstvení odpovídající zvolené variantě je v&nbsp;ceně degustace.</li>
        <li>U&nbsp;venkovních programů (piknik, degustace ve&nbsp;vinohradě, sezonní zážitky) domlouváme při nepřízni počasí individuálně vnitřní alternativu, náhradní program nebo jiný termín.</li>
        <li>Pokud poskytovatel službu neuskuteční a&nbsp;žádná přijatelná alternativa se nedohodne, neúčtuje se storno&nbsp;poplatek a&nbsp;případně již zaplacená částka za&nbsp;neposkytnutou službu se vrací.</li>
      </ul>

      <h2 id="vino">Prodej vína</h2>
      <p><strong>Prodávající:</strong> {W.name}, IČO&nbsp;{W.ico}. Prodej vína je určen výhradně osobám starším 18&nbsp;let; prodávající je oprávněn si věk při předání ověřit.</p>
      <ul>
        <li>Vyplněný formulář v&nbsp;košíku i&nbsp;samostatná poptávka vína jsou nezávazná poptávka, nikoli automaticky potvrzená objednávka.</li>
        <li>{W.name} po přijetí poptávky ověří aktuální dostupnost lahví.</li>
        <li>Kupujícímu zašle konečnou nabídku – potvrzení dostupných lahví, konečnou cenu, způsob platby a&nbsp;způsob převzetí.</li>
        <li>Osobní odběr, místní předání nebo jiný způsob doručení lze dohodnout individuálně podle potřeb kupujícího.</li>
        <li>Kupní smlouva vzniká až oboustranným potvrzením konečné nabídky.</li>
        <li>Web nenabízí automatické zásilkové odesílání, okamžitou skladovou dostupnost ani automatickou online platbu.</li>
      </ul>

      <h3>Reklamace vína</h3>
      <ul>
        <li>Reklamaci uplatňujte u&nbsp;prodávajícího na e-mail <a href={`mailto:${W.email}`}>{W.email}</a> bez zbytečného odkladu po zjištění vady.</li>
        <li>V&nbsp;reklamaci popište vadu a&nbsp;identifikujte zakoupený produkt (název vína, ročník, datum a&nbsp;způsob převzetí).</li>
        <li>Reklamace jsou vyřizovány podle platných předpisů České republiky na ochranu spotřebitele.</li>
      </ul>

      <h3>Odstoupení od kupní smlouvy uzavřené na dálku</h3>
      <p>
        Byla-li kupní smlouva na&nbsp;víno uzavřena distančním způsobem (např. e-mailem bez osobního odběru
        na provozovně) a&nbsp;kupujícím je spotřebitel, má právo odstoupit od&nbsp;smlouvy ve&nbsp;lhůtě 14&nbsp;dnů
        ode dne převzetí zboží, a to bez uvedení důvodu. Odstoupení zašle prodávajícímu na e-mail
        <a href={`mailto:${W.email}`}> {W.email}</a>. Kupující odpovídá za&nbsp;případné snížení hodnoty zboží
        v&nbsp;důsledku nakládání s&nbsp;ním jinak, než je nutné k&nbsp;seznámení s&nbsp;povahou a&nbsp;vlastnostmi zboží.
        Právo na&nbsp;odstoupení se neuplatní tam, kde je zákonem vyloučeno.
      </p>

      <h2 id="poukazy">Dárkové poukazy</h2>
      <ul>
        <li>Odeslaný formulář na&nbsp;stránce Dárkový poukaz je žádost o&nbsp;vystavení poukazu, nikoli automatická platba ani automatické vystavení.</li>
        <li>Poukaz vystavuje ten z&nbsp;provozovatelů, který poskytuje zvolenou službu:
          <ul>
            <li>{A.name} – poukazy na&nbsp;ubytování a&nbsp;na&nbsp;rodinný pobyt,</li>
            <li>{W.name} – poukazy na&nbsp;víno a&nbsp;samostatné degustace či jiné vinařské zážitky.</li>
          </ul>
        </li>
        <li>Vystavující provozovatel potvrdí zvolenou variantu a&nbsp;zašle platební pokyny.</li>
        <li>Platba probíhá předem bankovním převodem nebo QR&nbsp;platbou podle zaslaných pokynů.</li>
        <li>PDF poukaz je vystaven a&nbsp;zaslán až po&nbsp;připsání platby.</li>
        <li>Standardní platnost poukazu je 12&nbsp;měsíců ode&nbsp;dne vystavení, pokud na&nbsp;poukazu není uvedeno jinak.</li>
        <li>Konkrétní termín čerpání se domlouvá s&nbsp;obdarovaným podle aktuální dostupnosti; poukaz sám o&nbsp;sobě nezaručuje dostupnost konkrétního data.</li>
        <li>Nevyužitý poukaz je přenosný, ledaže byl výslovně vystaven na&nbsp;jmenovanou osobu a&nbsp;vystavující provozovatel se nedohodne jinak.</li>
        <li>Byla-li objednávka poukazu uzavřena distančním způsobem a&nbsp;kupujícím je spotřebitel, může nevyužitý poukaz stornovat ve&nbsp;lhůtě 14&nbsp;dnů ode&nbsp;dne uzavření smlouvy, pokud právo na&nbsp;odstoupení zákon nevylučuje. Žádost o&nbsp;odstoupení se zasílá vystavujícímu provozovateli.</li>
        <li>Po uplynutí zákonné 14denní lhůty na&nbsp;odstoupení nevzniká automatické právo na&nbsp;výměnu poukazu za&nbsp;peníze.</li>
        <li>Platnost poukazu lze na&nbsp;základě individuální dohody jednou prodloužit, pokud o&nbsp;to držitel požádá před uplynutím původní platnosti.</li>
        <li>Po&nbsp;uplynutí platnosti, která nebyla prodloužena, již poukaz nelze uplatnit.</li>
      </ul>

      <h2 id="reklamace">Reklamace a mimosoudní řešení sporů</h2>
      <p>
        Případnou reklamaci uplatňuje host / kupující u&nbsp;příslušného provozovatele bez zbytečného odkladu,
        a to e-mailem na kontaktní adresu uvedenou u&nbsp;dané služby nebo písemně na&nbsp;sídlo provozovatele.
        K&nbsp;mimosoudnímu řešení spotřebitelských sporů je věcně příslušná Česká obchodní inspekce, se&nbsp;sídlem
        Štěpánská 44, 120&nbsp;00 Praha&nbsp;2, <a href="https://www.coi.cz/" target="_blank" rel="noopener noreferrer">www.coi.cz</a>.
      </p>

      <h2 id="platnost">Platnost</h2>
      <p>Tyto obchodní podmínky jsou účinné dnem zveřejnění na&nbsp;webu. Aktuální znění je k&nbsp;dispozici na&nbsp;této stránce. Podmínky týkající se konkrétní služby platí ve&nbsp;znění účinném ke&nbsp;dni odeslání závazné rezervace, resp. potvrzení objednávky ze strany provozovatele.</p>
    </Legal>
  );
}

export function OchranaOsobnichUdaju() {
  return (
    <Legal path="/ochrana-osobnich-udaju" title="Ochrana osobních údajů" crumb="Ochrana osobních údajů">
      <p>
        Tento web provozují dva samostatní správci osobních údajů, kteří sdílejí veřejnou značku
        „Vinařství Brychta". Každý správce zpracovává údaje pouze v&nbsp;rozsahu potřebném pro svou vlastní službu.
      </p>

      <h2 id="spravci">Správci osobních údajů</h2>
      <p>
        <strong>Pro ubytování a rodinný pobyt:</strong> {A.name}, IČO&nbsp;{A.ico}, {formatAddress(A.registeredAddress)}.
        Kontakt ve&nbsp;věcech osobních údajů: <a href={`mailto:${A.email}`}>{A.email}</a>, {A.phone}.
      </p>
      <p>
        <strong>Pro víno, degustace a další vinařské zážitky:</strong> {W.name}, IČO&nbsp;{W.ico}, {formatAddress(W.registeredAddress)}.
        Kontakt ve&nbsp;věcech osobních údajů: <a href={`mailto:${W.email}`}>{W.email}</a>, {W.phone}.
      </p>
      <p className="text-sm text-charcoal/70">
        U&nbsp;balíčku „Rodinný pobyt na&nbsp;jižní Moravě" je hlavním smluvním poskytovatelem vůči hostovi
        {" "}{A.name}. Pro účel zajištění zahrnuté degustace může {A.name} předat společnosti {W.name}
        pouze nezbytné údaje potřebné k&nbsp;organizaci programu, zejména jméno hosta, datum, počet účastníků
        a&nbsp;nutné programové informace.
      </p>

      <h2 id="ucely">Účely a právní základy zpracování</h2>
      <ul>
        <li><strong>Vyřízení nezávazné poptávky</strong> odeslané formulářem – právní základ: opatření před uzavřením smlouvy na žádost subjektu údajů (čl.&nbsp;6 odst.&nbsp;1 písm.&nbsp;b GDPR).</li>
        <li><strong>Uzavření a plnění smlouvy</strong> o&nbsp;ubytování, rodinném pobytu, degustaci, prodeji vína nebo dárkovém poukazu – právní základ: plnění smlouvy (čl.&nbsp;6 odst.&nbsp;1 písm.&nbsp;b).</li>
        <li><strong>Plnění zákonných povinností</strong> – vedení účetnictví, evidence pro místní poplatek z&nbsp;pobytu, uchování dokladů (čl.&nbsp;6 odst.&nbsp;1 písm.&nbsp;c).</li>
        <li><strong>Obrana proti právním nárokům</strong> po ukončení služby – oprávněný zájem (čl.&nbsp;6 odst.&nbsp;1 písm.&nbsp;f).</li>
        <li><strong>Bezpečnost webu</strong> – oprávněný zájem na&nbsp;prevenci zneužití formulářů a&nbsp;na&nbsp;stabilním provozu (čl.&nbsp;6 odst.&nbsp;1 písm.&nbsp;f).</li>
      </ul>
      <p>Odeslání poptávkového formuláře není souhlasem s&nbsp;marketingovými zprávami. Marketingové zprávy neposíláme.</p>

      <h2 id="rozsah">Kategorie zpracovávaných údajů</h2>
      <ul>
        <li>Identifikační a kontaktní údaje: jméno a&nbsp;příjmení, e-mail, telefon.</li>
        <li>Údaje o&nbsp;poptávané / rezervované službě: termín, počet osob, preferovaný apartmán nebo zážitek, vaše zpráva.</li>
        <li>U&nbsp;dárkových poukazů: jméno obdarovaného (pokud jej uvedete) a&nbsp;věnování.</li>
        <li>Provozní údaje: IP adresa a&nbsp;údaje o&nbsp;prohlížeči při odeslání formuláře (log serverů kvůli bezpečnosti a&nbsp;prevenci zneužití).</li>
        <li>Případné UTM parametry z&nbsp;odkazů, které jste otevřeli, kvůli evidenci zdroje poptávky.</li>
      </ul>

      <h2 id="prijemci">Příjemci a zpracovatelé</h2>
      <p>Vaše údaje předáváme pouze v&nbsp;rozsahu nezbytném pro provoz webu a&nbsp;doručení odpovědi:</p>
      <ul>
        <li><strong>Poskytovatel hostingu webu, databáze a&nbsp;úložiště fotografií</strong> – zajišťuje technický provoz webu, uložení odeslaných poptávek a&nbsp;správu nahraných obrázků.</li>
        <li><strong>Resend</strong> – doručování transakčních e-mailů, kterými poskytovatel potvrzuje přijetí poptávky provozovateli a&nbsp;hostovi.</li>
        <li><strong>Banka a&nbsp;poskytovatelé platebních služeb</strong> – v&nbsp;rozsahu nutném pro přijetí zálohy nebo úhrady.</li>
        <li><strong>Účetní / daňový poradce</strong> a&nbsp;další příjemci pouze v&nbsp;rozsahu vyplývajícím ze&nbsp;zákona.</li>
      </ul>
      <p>
        Vaše údaje neprodáváme, nevyužíváme je pro marketingové profilování a&nbsp;nepředáváme je třetím stranám
        pro jejich vlastní marketing. Pokud kterýkoli z&nbsp;výše uvedených zpracovatelů zpracovává údaje mimo
        Evropský hospodářský prostor, je takové předání přípustné pouze při použití některého ze&nbsp;zákonných
        záruk podle GDPR.
      </p>

      <h2 id="doba">Doba uložení</h2>
      <ul>
        <li>Poptávka, která nevedla k&nbsp;rezervaci: zpravidla nejdéle 12&nbsp;měsíců od&nbsp;odeslání.</li>
        <li>Údaje z&nbsp;realizované rezervace, prodeje nebo poukazu: po dobu vyžadovanou účetními, daňovými a&nbsp;dalšími právními předpisy.</li>
        <li>Bezpečnostní logy: pouze po technicky nutnou dobu určenou poskytovatelem hostingu.</li>
      </ul>
      <p className="text-sm text-charcoal/70">
        Údaje, které je správce povinen uchovávat podle zákona (např. účetní a&nbsp;daňové doklady), nelze na&nbsp;žádost
        subjektu údajů smazat před uplynutím zákonné doby uchování.
      </p>

      <h2 id="prava">Vaše práva</h2>
      <p>Jako subjekt údajů máte právo:</p>
      <ul>
        <li>na&nbsp;přístup k&nbsp;údajům a jejich kopii;</li>
        <li>na&nbsp;opravu nepřesných údajů;</li>
        <li>na&nbsp;výmaz, pokud netrvá jiný zákonný důvod pro jejich uchování;</li>
        <li>na&nbsp;omezení zpracování;</li>
        <li>na&nbsp;přenositelnost údajů, které jste nám poskytli na základě smlouvy nebo souhlasu;</li>
        <li>vznést námitku proti zpracování založenému na oprávněném zájmu;</li>
        <li>podat stížnost u&nbsp;Úřadu pro ochranu osobních údajů (<a href="https://www.uoou.cz/" target="_blank" rel="noopener noreferrer">www.uoou.cz</a>, Pplk. Sochora&nbsp;27, 170&nbsp;00 Praha&nbsp;7).</li>
      </ul>
      <p>Práva u&nbsp;kteréhokoli správce uplatňujte na jeho výše uvedený kontakt. Odpovíme bez zbytečného odkladu, nejpozději do&nbsp;30&nbsp;dnů.</p>

      <h2 id="cookies">Cookies a sledování</h2>
      <p>Používání cookies a&nbsp;podobných technologií popisujeme samostatně na&nbsp;stránce <Link to="/cookies" className="underline hover:text-burgundy">Cookies</Link>.</p>

      <h2 id="platnost">Platnost</h2>
      <p>Tato informace o zpracování osobních údajů je platná dnem zveřejnění. Aktualizované znění je vždy k&nbsp;dispozici na této stránce.</p>
    </Legal>
  );
}

export function Cookies() {
  return (
    <Legal path="/cookies" title="Cookies" crumb="Cookies">
      <p>
        Veřejná část webu Vinařství Brychta / Ubytování u&nbsp;vinaře v&nbsp;současné době
        <strong> nepoužívá volitelné analytické ani marketingové soubory cookie</strong>.
      </p>

      <h2 id="nezbytne">Technicky nezbytné technologie</h2>
      <p>
        Pro správný chod webu a&nbsp;jeho bezpečnost mohou být využity technicky nezbytné technologie,
        například krátkodobé identifikátory relace nebo obranné mechanismy proti zneužití formulářů.
        Tyto technologie nesledují návštěvníky napříč weby a&nbsp;fungují bez zvláštního souhlasu, protože
        jsou nezbytné pro poskytnutí služby, o&nbsp;kterou návštěvník žádá.
      </p>

      <h2 id="admin">Přihlášení do administrace</h2>
      <p>
        Pouze při přihlášení oprávněného provozovatele do&nbsp;administrace <code>/admin</code>
        se&nbsp;v&nbsp;prohlížeči nastavuje bezpečnostní autentizační cookie s&nbsp;podepsaným tokenem,
        omezenou platností a&nbsp;příznaky HttpOnly&nbsp;+&nbsp;Secure. Na běžné návštěvníky webu se tato cookie
        nevztahuje.
      </p>

      <h2 id="analytika">Analytika a marketing</h2>
      <p>
        Web nemá aktivní Google Analytics, Google Ads, Meta Pixel ani jiný marketingový skript. Volitelné
        analytické nástroje nebudou v&nbsp;budoucnu aktivovány bez aktualizace této informace a&nbsp;bez získání
        případného zákonného souhlasu.
      </p>

      <h2 id="dalsi">Další informace</h2>
      <p>
        Podrobnější informace o&nbsp;tom, kdo a&nbsp;proč vaše údaje zpracovává, najdete v&nbsp;dokumentu
        <Link to="/ochrana-osobnich-udaju" className="underline hover:text-burgundy"> Ochrana osobních údajů</Link>.
      </p>
    </Legal>
  );
}

export function Provozovatele() {
  return (
    <Legal path="/provozovatele" title="Provozovatelé" crumb="Provozovatelé">
      <p>
        Značka „Vinařství Brychta" je společně užívána dvěma samostatnými podnikajícími fyzickými
        osobami. Každý provozovatel zajišťuje odlišnou část služeb a&nbsp;odpovídá pouze za&nbsp;ni.
      </p>

      <h2>Ubytování a rodinný pobyt</h2>
      <ul>
        <li>{A.name}</li>
        <li>IČO&nbsp;{A.ico}, fyzická osoba podnikající zapsaná v&nbsp;živnostenském rejstříku</li>
        <li>Sídlo: {formatAddress(A.registeredAddress)}</li>
        <li>Místo poskytování ubytování: {formatAddress(A.operatingAddress)}</li>
        <li>E-mail: <a href={`mailto:${A.email}`}>{A.email}</a></li>
        <li>Telefon: {A.phone}</li>
      </ul>

      <h2>Vína a degustace</h2>
      <ul>
        <li>{W.name}</li>
        <li>IČO&nbsp;{W.ico}, fyzická osoba podnikající zapsaná v&nbsp;živnostenském rejstříku</li>
        <li>Sídlo: {formatAddress(W.registeredAddress)}</li>
        <li>E-mail: <a href={`mailto:${W.email}`}>{W.email}</a></li>
        <li>Telefon: {W.phone}</li>
      </ul>
    </Legal>
  );
}

function Legal({ path, title, crumb, children }) {
  return (
    <main id="main">
      <Seo path={path} title={`${title} | Vinařství Brychta`} description="Právní informace k webu Vinařství Brychta a Ubytování u vinaře." />
      <Breadcrumbs items={[{ label: crumb }]} />
      <section className="max-w-3xl mx-auto px-5 md:px-10 py-14 md:py-20 prose-czech legal-page">
        <h1 className="font-serif font-light text-4xl md:text-5xl mb-6">{title}</h1>
        {children}
      </section>
      <style>{`
        .legal-page h2 { font-family: Fraunces, serif; font-weight: 300; font-size: 1.6rem; margin-top: 2.25rem; margin-bottom: .75rem; color: #25231F; }
        .legal-page h3 { font-family: Fraunces, serif; font-weight: 300; font-size: 1.2rem; margin-top: 1.75rem; margin-bottom: .5rem; color: #25231F; }
        .legal-page p { margin: .6rem 0; line-height: 1.7; color: rgba(37,35,31,.85); }
        .legal-page ul { list-style: disc; padding-left: 1.25rem; margin: .5rem 0 .75rem; }
        .legal-page ul ul { margin: .3rem 0 .3rem .5rem; }
        .legal-page li { margin: .3rem 0; line-height: 1.65; color: rgba(37,35,31,.85); }
        .legal-page a { color: #711934; text-decoration: underline; text-underline-offset: 2px; }
        .legal-page code { background: #F5F0E7; padding: 0 .25rem; border-radius: 2px; font-size: .9em; }
      `}</style>
    </main>
  );
}
